import { render, staticRenderFns } from "./GoldBalanceWithdrawList.vue?vue&type=template&id=957fb4dc&scoped=true"
import script from "./GoldBalanceWithdrawList.vue?vue&type=script&lang=js"
export * from "./GoldBalanceWithdrawList.vue?vue&type=script&lang=js"
import style0 from "./GoldBalanceWithdrawList.vue?vue&type=style&index=0&id=957fb4dc&prod&lang=css"
import style1 from "./GoldBalanceWithdrawList.vue?vue&type=style&index=1&id=957fb4dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957fb4dc",
  null
  
)

export default component.exports